// Created by jarongallo at 3/30/21
import React, { useEffect, useState } from 'react';
import PLFilters from '../../../../../components/PL/PLFilters';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import { SERVICES_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { useLazyQuery } from '@apollo/react-hooks';
import { PHOTOSHOOT_TYPE_SERVICE } from '../../../../../utils/Config/Constants';
import { GET_TECHNICIAN_SERVICES } from './queries';
import * as strings from './strings';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import { useLocation } from 'react-router-dom';
import { PLFILTER_TYPE_SERVICE } from '../../../../../components/PL/PLFilters/config';

export default function IndividualTechnicianNetworkServices({ technicianId }: IndividualTechnicianNetworkServicesProps) {
	const [services, setServices] = useState<ServiceType[]>();

	let baseVariables = {
		query: {
			type: { op_eq: PHOTOSHOOT_TYPE_SERVICE },
			clientId: { op_ne: technicianId },
			op_or: [{ photographerId: { op_eq: technicianId } }, { traineeId: { op_eq: technicianId } }]
		}
	};

	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(20, SERVICES_TABLE_TYPE, props, baseVariables);
	const [getServices, { data: servicesData }] = useLazyQuery(GET_TECHNICIAN_SERVICES, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getServices();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (servicesData) {
				const fetchedServices: ServiceType[] = servicesData['services'];
				setServices(fetchedServices);
			}
		})();
	}, [servicesData]);

	if (!services) return null;

	return (
		<div className='individualTechnician__content-tables'>
			<div className='general-header-pin'>
				<PLFilters type={PLFILTER_TYPE_SERVICE} updateTable={getServices} />
				<UISearchBar type={UI_SEARCH_BAR_TYPES.service} onSearchUpdated={getServices} placeholder={'search...'} />
			</div>
			<PLTable emptySetText={strings.noServices} type={SERVICES_TABLE_TYPE} limit={20} updateTable={getServices} data={services} />
		</div>
	);
}
